import Vue from 'vue';
import Component from 'vue-class-component';
import EdHeaderInSession from '@/core/components/ed-header-in-session/ed-header-in-session.vue';

@Component({
  components: {
    EdHeaderInSession
  }
})
export default class PrivateView extends Vue {

  get hasHeader(): boolean {
    return this.$store.state.AppStore.header.visible;
  }

}